export enum PaymentMethod {
  Unknown,
  DirectDebit,
  BankTransfer,
}
